import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { unwrappedSelectedPlayerNameAtom } from '@/atoms/player/info';
import { unwrappedPlayerComparisonNameAtom } from '@/atoms/queries/player/playerComparisonRadar';
import { ComparisonFilterTabs } from '@/components/filters/ComparisonFilterTabs';
import { useIsCompetitionAverageMode } from '@/hooks/useIsCompetitionAverageMode';
import { PlayerComparisonHighLevelFilters } from './PlayerComparisonHighLevelFilters';
import { PlayerCompetitionAveragePanel } from './PlayerCompetitionAveragePanel';
import { PlayerHighLevelFilters } from './PlayerHighLevelFilters';

export const PlayerFilterTabs = () => {
  const { t } = useTranslation('radar');
  const primaryName = useAtomValue(unwrappedSelectedPlayerNameAtom);
  const entityComparisonName = useAtomValue(unwrappedPlayerComparisonNameAtom);
  const isCompetitionAverageMode = useIsCompetitionAverageMode();
  const comparisonName = isCompetitionAverageMode ? t('competitionAverage.optionLabel') : entityComparisonName;

  return (
    <ComparisonFilterTabs
      primaryName={primaryName}
      comparisonName={comparisonName}
      primaryFilters={<PlayerHighLevelFilters />}
      comparisonFilters={
        isCompetitionAverageMode ? <PlayerCompetitionAveragePanel /> : <PlayerComparisonHighLevelFilters />
      }
    />
  );
};
